export default function getClassName(ins) {
  var _ins$optionsManager$s = ins.optionsManager.setting,
    showMorePopperClass = _ins$optionsManager$s.showMorePopperClass,
    tablistViewClass = _ins$optionsManager$s.tablistViewClass,
    verticalClass = _ins$optionsManager$s.verticalClass,
    rtlClass = _ins$optionsManager$s.rtlClass;
  return tablistViewClass + ' ' + verticalClass + ' ' + (ins.getOption('direction') == 'rtl' ? rtlClass + ' ' : '') + showMorePopperClass;
}